'use strict';

const { h, Component } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const { hydrate } = require('@grpn/hydration');
const Search = require('../../search/views/search');
const { pruneData } = require('../../../modules/support/prune-data');
const MerchantsDropdown = require('./merchants-dropdown');

const {
  getMainNavigationItems,
} = require('../../../modules/support/menu-helper');

class MainMenu extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { showMerchants: false };

    this.clickHandlerShowMerchants = this.clickHandlerShowMerchants.bind(this);
    this.onWindowClick = this.onWindowClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  render() {
    const {
      activePage,
      routes,
      themedPage,
      searchCredentials,
      showTopOffers,
      merchants,
    } = this.props;
    const { showMerchants } = this.state;

    const navigationItems = getMainNavigationItems({
      activePage,
      routes,
      themedPage,
      showTopOffers,
    });

    return h('.main-menu-wrapper', [
      h('.page-container', [
        h('.row', [
          h(
            '.column',
            h(
              'nav',
              {
                'data-bhw': 'CouponsNav',
              },
              [
                ...navigationItems.map(item => this.getNavLink(item)),
                h(
                  'a',
                  {
                    class: `main-menu-link popular-stores-link
                    ${
                      (showMerchants || activePage === 'all-brands') && 'active'
                    }`,
                    onClick: this.clickHandlerShowMerchants,
                    'data-bhc': 'nav:PopularMerchants',
                  },
                  h(Translate, 'js.modules.header.PopularMerchants')
                ),
                this.getBlogItem(),
              ]
            )
          ),
          h(
            '.column',
            h(Search, {
              searchCredentials,
              routes: pruneData(routes, 'merchant:show'),
            })
          ),
        ]),
        MerchantsDropdown(routes, showMerchants, merchants),
      ]),
    ]);
  }

  clickHandlerShowMerchants(ev) {
    const { showMerchants } = this.state;

    ev.stopPropagation();

    this.setState({
      showMerchants: !showMerchants,
    });
  }

  onWindowClick() {
    this.setState({
      showMerchants: false,
    });
  }

  getNavLink({ active, key, href, page, linkText }) {
    if (linkText) {
      return h(
        `a.main-menu-link.${active}`,
        { href, 'data-bhc': `nav:${page}` },
        linkText
      );
    }

    return h(
      Translate,
      {
        tag: 'a',
        attrs: {
          href,
          class: `main-menu-link ${active}`,
          'data-bhc': `nav:${page}`,
        },
      },
      `js.modules.header.${key}`
    );
  }

  getBlogItem() {
    const { blogUrl } = this.props;

    if (!blogUrl) {
      return null;
    }

    const blog = {
      page: 'blog',
      text: 'js.modules.header.BlogLinkText',
      href: blogUrl,
    };

    return h(
      Translate,
      {
        tag: 'a',
        attrs: {
          href: blog.href,
          class: 'main-menu-link',
          'data-bhc': `nav:${blog.page}`,
          target: '_blank',
        },
      },
      blog.text
    );
  }
}

module.exports = hydrate('MainMenu', MainMenu);
